import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import userResources from '@/api/user'
import { useAppContext } from '@/App.context'

const useUser = () =>
  useQuery(queries.user(), userResources.get, {
    staleTime: Infinity,
  }).data

export default useUser

export const useProfile = () =>
  useQuery(queries.profile(), userResources.getProfile, {
    staleTime: Infinity,
  }).data

export const useFullUserName = () => {
  const profile = useProfile()
  const fullName =
    profile?.firstName || profile?.lastName ? `${profile?.firstName} ${profile?.lastName}` : ''

  return fullName
}

export const useIsBechtle = () => {
  const { whiteLabel } = useAppContext()

  return ['bechtle', 'arp'].includes(whiteLabel)
}

export const useIsBechtleDemoUser = () => {
  const user = useUser()

  return user?.id === 4070
}

export const useIsElkjop = () => {
  const { whiteLabel } = useAppContext()

  return whiteLabel === 'elkjop'
}

export const useIsDustin = () => {
  const profile = useProfile()

  return profile?.username.toLowerCase() === 'dustin'
}

export const useIsMobit = () => {
  const { whiteLabel } = useAppContext()

  return whiteLabel === 'mobit'
}

export const useHasSalesSupport = () => Boolean(useProfile()?.hasSalesSupport)

export const useEditTranslationsPrivilege = () => {
  const user = useUser()

  if (!user) return 'CANNOT_EDIT'

  return user?.editTranslationsPrivilege
}
